import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useMemo, useState } from 'react';
import { EStepTransitionStatus } from '../../types';
import { createStepHistory, getNextStep, getStepsProgress } from './internal/utils';
import { ENavigationDirections, EStepUnreachableErrorPolicy } from '../../constants';
var defaultConfig = {
  onStepUnreachable: EStepUnreachableErrorPolicy.Error
};
export var useStepWizard = function useStepWizard(props) {
  var scheme = props.scheme,
    firstStepCode = props.firstStepCode,
    _props$config = props.config,
    config = _props$config === void 0 ? defaultConfig : _props$config;
  var _useState = useState(createStepHistory(_objectSpread({
      unreachablePolicy: config.onStepUnreachable,
      firstStepCode: firstStepCode,
      scheme: scheme
    }, props.initialParams))),
    _useState2 = _slicedToArray(_useState, 2),
    stepsHistory = _useState2[0],
    setStepsHistory = _useState2[1];
  var currentStep = stepsHistory[stepsHistory.length - 1];
  var progress = useMemo(function () {
    return getStepsProgress({
      currentStep: currentStep,
      stepsHistory: stepsHistory,
      scheme: props.scheme
    });
  }, [props.scheme, stepsHistory, currentStep]);
  var nextStep = function nextStep(params) {
    var direction = ENavigationDirections.Forward;
    try {
      var step = getNextStep({
        answers: params.answers,
        skipSteps: params.skipSteps,
        currentStep: currentStep,
        scheme: scheme
      });
      if (!step) {
        return {
          status: EStepTransitionStatus.Boundary,
          direction: direction,
          history: stepsHistory
        };
      }
      var historyCandidate = [].concat(_toConsumableArray(stepsHistory), [step]);
      return {
        status: EStepTransitionStatus.Ready,
        direction: direction,
        history: historyCandidate,
        step: step,
        navigate: function navigate() {
          return setStepsHistory(historyCandidate);
        }
      };
    } catch (error) {
      return {
        status: EStepTransitionStatus.Error,
        error: error,
        direction: direction
      };
    }
  };
  var prevStep = function prevStep() {
    var direction = ENavigationDirections.Backward;
    var step = stepsHistory[stepsHistory.length - 2];
    if (!step) {
      return {
        status: EStepTransitionStatus.Boundary,
        direction: direction,
        history: stepsHistory
      };
    }
    var historyCandidate = stepsHistory.slice(0, -1);
    return {
      status: EStepTransitionStatus.Ready,
      direction: direction,
      history: historyCandidate,
      step: step,
      navigate: function navigate() {
        return setStepsHistory(historyCandidate);
      }
    };
  };
  var stepByCode = function stepByCode(params) {
    var direction = ENavigationDirections.Direct;
    try {
      var historyCandidate = createStepHistory(_objectSpread({
        unreachablePolicy: config.onStepUnreachable,
        firstStepCode: firstStepCode,
        scheme: scheme
      }, params));
      var step = historyCandidate[historyCandidate.length - 1];
      return {
        status: EStepTransitionStatus.Ready,
        direction: direction,
        history: historyCandidate,
        step: step,
        navigate: function navigate() {
          return setStepsHistory(historyCandidate);
        }
      };
    } catch (error) {
      return {
        status: EStepTransitionStatus.Error,
        error: error,
        direction: direction
      };
    }
  };
  return {
    nextStep: nextStep,
    prevStep: prevStep,
    stepByCode: stepByCode,
    stepsHistory: stepsHistory,
    currentStep: currentStep,
    progress: progress
  };
};